export default __webpack_public_path__ + "static/iraida-cf64348ab1526d08eb8d7b2b1b77e0c1.png";